import { render, staticRenderFns } from "./VekaletList.vue?vue&type=template&id=55786602"
import script from "./VekaletList.vue?vue&type=script&lang=ts"
export * from "./VekaletList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports